import React, { useEffect, useMemo, useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Button, TextField, Chip, Tabs, Tab, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, Menu, MenuItem, InputAdornment } from '@mui/material';
import { PlayArrow, GridView, TableView, MoreVert } from '@mui/icons-material';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from "packages/novous_web/src/authContext/useAuth";
import axiosInstance from "../../../../../api/apiClient";
import { useNavigate } from 'react-router-dom';
import AlertsGrid from '../../Vehicle-Alerts/components/AlertDataGrid';
import AlertsTable from '../../Vehicle-Alerts/components/AlertDataTable';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg'
import calendar from "packages/novous_web/src/assets/icons/calendar.svg";
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import dayjs from 'dayjs';
import arrow from "packages/novous_web/src/assets/icons/Arrow.svg";
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg'
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg'
import { getWarningIcon } from '../../Vehicle-Alerts/helper/warningIcons';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import { MRT_ColumnDef } from 'material-react-table';
import infoIcon from "../../../../../assets/icons/i.svg";
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';

interface Alert {
    id: string;
    driverName: string;
    vehicleNumber: string;
    timestamp: string;
    warningString: string;
}

interface WarningData {
    warningName: string;
    alerts: Alert[];
}
type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};


const DriverAlertsData = ({ dateState, driverId }: any) => {
    const theme = useTheme();
    const { user } = useAuth();
    const [warnings, setWarnings] = useState<any>(null);
    const [criticalWarning, setCriticalWarning] = useState<any>([]);
    const [nonCriticalWarning, setNonCriticalWarning] = useState<any>([]);
    const [alertsMap, setAlertsMap] = useState<{ [key: string]: { alerts: any[] } }>({});
    const [warningType, setWarningType] = useState<any>();
    const alertsDataArr: any = [];
    const [allWarningTypes, setAllWarningTypes] = useState<any>([]);
    const [newData, setNewData] = useState<WarningData[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(
        null
    );
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [filteredData, setFilteredData] = useState<any>();
    const [showDatePicker, setShowDatePicker] = useState(false);
    console.log('dateStaate', dateState);
    const [startDate, setStartDate] = useState(dateState.startDate || "");
    const [endDate, setEndDate] = useState(dateState.startDate || "");
    const dateRangeArr = [
        "Today",
        "Yesterday",
        "7 Days",
        "15 Days",
        "30 Days",
        "Custom Range",
    ];
    const [selectedDuration, setSelectedDuration] = useState(dateState.selectedDuration || dateRangeArr[0]);
    const { data: alert1Data, fetchData: fetch1AlertData } = useAxios<any>(
        `${API_ENDPOINTS.alarm.DRIVER_ALERT_ALL_WARNING}`,
        "POST"
    );
    const [isFilterModel, setIsFilterModelOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<'all' | 'critical' | 'nonCritical'>('all');
    const [viewMode, setViewMode] = useState<'grid' | 'table'>('grid');
    const navigate = useNavigate(); // Add from react-router-dom
    const handleFilterClose = () => setIsFilterModelOpen(false);
    const handleFilterOpen = () => setIsFilterModelOpen(true);
    useEffect(() => {
        if (user?.customer_id) {
            fetch1AlertData({ fleetId: user.customer_id, startDate: startDate, endDate: endDate });
        }
    }, [user]);

    useEffect(() => {
        if (alert1Data?.data) {
            setWarnings(alert1Data.data);
            setCriticalWarning(alert1Data.data.criticalWarningType || []);
            setNonCriticalWarning(alert1Data.data.nonCriticalWarningType || []);
            setAllWarningTypes([...(alert1Data.data.criticalWarningType || []), ...(alert1Data.data.nonCriticalWarningType || [])]);
        }
    }, [alert1Data]);
    useEffect(() => {
        if (activeTab === 'all') {
            fetchAllAlertsParallel(allWarningTypes);
        } else if (activeTab === 'critical') {
            fetchAllAlertsParallel(criticalWarning);
        } else if (activeTab === 'nonCritical') {
            fetchAllAlertsParallel(nonCriticalWarning);
        }
    }, [activeTab, allWarningTypes, criticalWarning, nonCriticalWarning]);
    useEffect(() => {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }, [selectedDuration]);
    const fetchAllAlertsParallel = async (warningTypes: string[], vehicleGroup?: string, vehicleId?: string) => {
        try {
            setLoading(true);
            setError(null);

            const requests = warningTypes.map(warningType =>
                axiosInstance({
                    url: API_ENDPOINTS.alarm.DRIVER_PAGINATED_ALERT_BY_WARNING,
                    method: "POST",
                    data: {
                        fleetId: user?.customer_id,
                        startDate: dateState.startDate,
                        endDate: dateState.endDate,
                        warningType,
                        lastEvaluatedKey: null,
                        // driverId: '67e3e47fc374c3656a16ece4',
                        // driverId: '679b5f66c374c339425cdccf',
                        driverId: driverId,
                        ...(vehicleGroup && { vehicleGroup: vehicleGroup }),
                        ...(vehicleId && { vehicleId: vehicleId }),
                    },
                    responseType: "json"
                }).then(response => ({
                    warningName: warningType,
                    alerts: response.data || [],
                })).catch(error => ({
                    warningName: warningType,
                    alerts: [],
                    error: error.message
                }))
            );

            const results = await Promise.all(requests);
            console.log("Results:", results);
            let filteredDataArr = [];
            filteredDataArr = results.map((result: any) => ({
                warningName: result.warningName,
                totalRecords: result.alerts?.data?.totalRecords || 0,
                alerts: Array.isArray(result.alerts?.data?.actualWarningList)
                    ? result.alerts.data.actualWarningList.filter(
                        (alert: any) =>
                            alert?.vehicleNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            alert?.device_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            alert?.vehicleId?.toLowerCase().includes(searchQuery.toLowerCase())
                    )
                    : [],
            }));
            const updatedResults = filteredDataArr.map(result => ({
                ...result,
                isCritical: criticalWarning.includes(result.warningName) // Check if warningName is in criticalWarning array
            }));
            console.log("Updated Results:", updatedResults);
            setNewData(updatedResults);

            return updatedResults;

        } catch (error) {
            setError(error instanceof Error ? error.message : 'Unknown error occurred');
            return [];
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (startDate && endDate) {
            fetchAllAlertsParallel(allWarningTypes);
        }
    }, [startDate, endDate, selectedDuration, searchQuery, dateState]);

    const formatTimestamp = (timestamp: string) => {
        const [year, month, day, hour, minute, second] = timestamp?.split('_');
        const date = new Date(
            `${year}-${month}-${day}T${hour}:${minute}:${second}`
        );
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).replace(',', '');
    };

    const getDateRange = (range: string) => {
        const today = dayjs();
        let startDate, endDate;

        switch (range) {
            case "Today":
                startDate = today.format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "Yesterday":
                startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
                endDate = startDate;
                break;
            case "7 Days":
                startDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "15 Days":
                startDate = dayjs().subtract(14, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "30 Days":
                startDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            default:
                startDate = "";
                endDate = "";
        }
        return { startDate, endDate };
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setCalendarAnchorEl(event.currentTarget);
    };


    const handleCalendarClose = () => {
        setShowDatePicker(false);
        // setStartDate("");
        // setEndDate("");

        // setSelectedDuration(dateRangeArr[0]);
        setCalendarAnchorEl(null);
    };
    const handleClose = (value?: string) => {
        console.log("Selected Value:", value);

        if (value) {
            // Only reset dates if changing FROM custom range TO another option
            if (selectedDuration === "Custom Range" && value !== "Custom Range") {
                const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
                setStartDate(newStartDate);
                setEndDate(newEndDate);
            }

            setSelectedDuration(value);
            setShowDatePicker(value === "Custom Range");

            // If selecting Custom Range again, don't reset the dates - keep existing values
            if (value === "Custom Range") {
                setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
            }
        }

        setAnchorEl(null);
    };

    const handleViewAll = (warning: any) => {
        const params = new URLSearchParams();
        const warningData: any = newData.find((item) => item.warningName === warning);
        params.set("warningName", warning);
        if (warningData) {
            params.set("isCritical", warningData.isCritical ? "true" : "false");
        }
        if (viewMode) {
            params.set("viewMode", viewMode);
        }
        if (startDate && endDate) {
            params.set("startDate", startDate);
            params.set("endDate", endDate);
        }
        if (selectedDuration) {
            params.set("selectedDuration", selectedDuration);
        }
        navigate(`/alarm/vehicle-all-alerts?${params.toString()}`, { state: { calledFromDriverAlerts: true, driverId: driverId } });
    };

    const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);

    const handleCustomiseModalOpen = (event: any) => {
        setIsCustomiseModalOpen(true);
    };

    const handleFilterSave = (data: any) => {
        fetchAllAlertsParallel(allWarningTypes, data.group, data.vehicle);
    }
    const [columnObj, setColumnObj] = useState<ColumnObjType>({
        date_time: { name: "Date and Time", status: true },
        vehicleId: { name: "Vehicle Reg No", status: true },
        actions: { name: "Actions", status: true }
    });
    return (
        <Box className="text-gray-800 p-4">
            <Box className="flex justify-between items-center mb-4 flex-wrap gap-4">
                {/* Left - Alerts text */}
                <Typography>Alerts</Typography>

                {/* Middle - Critical/non-critical tabs */}
                <Box className="flex gap-2 flex-wrap">
                    <Tabs
                        value={activeTab}
                        onChange={(e, newVal) => setActiveTab(newVal)}
                        sx={{
                            borderRadius: "8px",
                            padding: "4px",
                            backgroundColor: theme.palette.selected,
                        }}
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab
                            label="All"
                            value="all"
                            sx={{
                                ...(activeTab === 'all'
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "8px 16px",
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                        <Tab
                            label="Critical"
                            value="critical"
                            sx={{
                                ...(activeTab === 'critical'
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "8px 16px",
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                        <Tab
                            label="Non Critical"
                            value="nonCritical"
                            sx={{
                                ...(activeTab === 'nonCritical'
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "8px 16px",
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                    </Tabs>
                </Box>

                {/* Right - Grid/table tabs */}
                <Box className="flex gap-2 items-center">
                    {viewMode === 'table' && <CustomIconButton
                        icon={<img src={Custom} alt="Custom" width={16} height={16} />}
                        text="Customize"
                        background='transparent'
                        outline={false}
                        onClick={handleCustomiseModalOpen}
                    />}
                    <Tabs
                        value={viewMode}
                        onChange={(e, newVal) => setViewMode(newVal)}
                        sx={{
                            borderRadius: "8px",
                            padding: "4px",
                            backgroundColor: theme.palette.selected,
                        }}
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab
                            label=""
                            value="grid"
                            icon={<GridView />}
                            iconPosition="start"
                            sx={{
                                ...(viewMode === 'grid'
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                        <Tab
                            label=""
                            value="table"
                            icon={<TableView />}
                            iconPosition="start"
                            sx={{
                                ...(viewMode === 'table'
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                    </Tabs>
                </Box>
            </Box>

            {/* Warnings List */}
            <Box className={`${viewMode === 'table' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'space-y-8'}`}>
                {newData?.map((warning: any, index) => (
                    <Box key={warning.warningName + index} className={`${viewMode === 'table' ? 'w-full bg-white rounded-lg shadow-sm' : 'space-y-4'}`}>
                        {/* Warning Header */}
                        <Box className="flex justify-between items-center bg-white p-2 rounded-lg">
                            <Box className="flex items-center gap-2">
                                <img src={getWarningIcon(warning.warningName)} />
                                <Typography
                                    variant="h6"
                                    className={`font-semibold ${warning.warningName === 'SOS' ? 'text-red-500' : ''}`}
                                    sx={{
                                        fontFamily: 'Inter Tight',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '18px',
                                        letterSpacing: '0%',
                                        textTransform: 'uppercase',
                                        color: warning.warningName === 'SOS' ? 'red' : '#767676',
                                    }}
                                >
                                    {warning.warningName.toUpperCase()}
                                </Typography>
                                <img
                                    src={infoIcon}
                                    alt="info icon"
                                    title="More info"
                                    className="w-4 h-4 cursor-pointer"
                                />
                                <Chip
                                    label={warning.totalRecords || 0}
                                    size="small"
                                    sx={{
                                        width: 54,
                                        height: 24,
                                        gap: '10px',
                                        borderRadius: '4px',
                                        backgroundColor: '#EAE9F5',
                                        color: 'black'
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: warning.isCritical ? 57 : 100,
                                        height: 24,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: warning.isCritical ? '10px' : '4px',
                                        borderRadius: '8px',
                                        padding: '4px 8px',
                                        backgroundColor: warning.isCritical ? '#F7E1E1' : '#FFF4E1',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Inter Tight',
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '21px',
                                            letterSpacing: '0%',
                                            color: warning.isCritical ? '#C83333' : '#A9861E',
                                        }}
                                    >
                                        {warning.isCritical ? 'Critical' : 'Non Critical'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className="flex justify-between items-center bg-white p-3 rounded-lg shadow-sm">
                                <Button
                                    variant="outlined"
                                    onClick={() => handleViewAll(warning.warningName)}
                                    endIcon={<CallMadeIcon />} // Add the CallMadeIcon here
                                >
                                    View All
                                </Button>
                            </Box>
                        </Box>

                        {/* Alerts Grid */}
                        {viewMode === 'grid' ? (
                            warning.alerts?.length > 0 ? (
                                <AlertsGrid alerts={warning.alerts} />
                            ) : (
                                <Box className="p-4 text-center text-gray-500">
                                    No records found for this warning
                                </Box>
                            )
                        ) : viewMode === 'table' ? (
                            warning.alerts?.length > 0 ? (
                                <AlertsTable alerts={warning.alerts} warning={warning.warningName} startDate={startDate} endDate={endDate} driverId={driverId} calledFromDriverAlerts={true} columnObj={columnObj} />
                            ) : (
                                <Box className="p-4 text-center text-gray-500">
                                    No records found for this warning
                                </Box>
                            )
                        ) : (
                            <Box className="p-4 text-center text-gray-500">
                                No alerts found for this warning type
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
            <FilterDataModel
                open={isFilterModel}
                onClose={handleFilterClose}
                handleFilterSave={handleFilterSave}
                title="Filter"
                description="Use the options below to refine your search and find specific alerts quickly."
                showTripStatus={false}
                trgtcData={true}
            />
        </Box>
    );
};

export default DriverAlertsData;
